import React from 'react';
import BowlMark from './BowlMark';
import { BRAND } from '../brand';
import './WalletPreview.css';

export const WALLET_PASSES = [
  {
    id: 'boursier',
    typeLabel: 'Boursier',
    background: 'var(--boursier)',
  },
  {
    id: 'standard',
    typeLabel: 'Standard',
    background: 'var(--standard)',
  },
  {
    id: 'autre',
    typeLabel: 'Autre',
    background: 'var(--other)',
  },
];

const QrMark = () => (
  <svg className="pass-qr" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
    <rect x="2" y="2" width="18" height="18" rx="2" fill="currentColor" />
    <rect x="6" y="6" width="10" height="10" fill="var(--pass-bg, currentColor)" />
    <rect x="8.5" y="8.5" width="5" height="5" fill="currentColor" />
    <rect x="28" y="2" width="18" height="18" rx="2" fill="currentColor" />
    <rect x="32" y="6" width="10" height="10" fill="var(--pass-bg, currentColor)" />
    <rect x="34.5" y="8.5" width="5" height="5" fill="currentColor" />
    <rect x="2" y="28" width="18" height="18" rx="2" fill="currentColor" />
    <rect x="6" y="32" width="10" height="10" fill="var(--pass-bg, currentColor)" />
    <rect x="8.5" y="34.5" width="5" height="5" fill="currentColor" />
    <rect x="28" y="28" width="6" height="6" fill="currentColor" />
    <rect x="36" y="28" width="10" height="4" fill="currentColor" />
    <rect x="28" y="38" width="18" height="8" fill="currentColor" />
  </svg>
);

export const WalletPass = ({ typeLabel, background, company = BRAND.sampleCompany }) => (
  <article
    className="wallet-pass"
    style={{ '--pass-bg': background, background }}
    aria-label={`Pass ${typeLabel}, ${company}`}
  >
    <header className="pass-top">
      <div className="pass-brand">
        <BowlMark size={28} decorative />
        <span className="pass-company">{company}</span>
      </div>
      <p className="pass-status">
        Statut
        <strong>Actif</strong>
      </p>
    </header>
    <p className="pass-balance-label">Solde FCFA</p>
    <p className="pass-balance">12 500</p>
    <dl className="pass-meta">
      <div>
        <dt>Titulaire</dt>
        <dd>Ada Lovelace</dd>
      </div>
      <div>
        <dt>N° carte</dt>
        <dd>0715 9426</dd>
      </div>
      <div>
        <dt>Plafond / jour</dt>
        <dd>Illimité</dd>
      </div>
      <div>
        <dt>Valable jusqu’au</dt>
        <dd>31/12/2026</dd>
      </div>
    </dl>
    <div className="pass-footer">
      <QrMark />
      <span>0715 9426</span>
    </div>
  </article>
);

const WalletPreview = ({ layout = 'row' }) => (
  <div className={`wallet-preview wallet-preview-${layout}`}>
    {WALLET_PASSES.map((pass) => (
      <figure key={pass.id} className={`wallet-figure wallet-figure-${pass.id}`}>
        <WalletPass typeLabel={pass.typeLabel} background={pass.background} />
        <figcaption>{pass.typeLabel}</figcaption>
      </figure>
    ))}
  </div>
);

export default WalletPreview;
